import styles from "@/components/ai-tools-footer.module.css";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import { JSX } from "react";

function AiToolsFooter(): JSX.Element {
	return (
		<footer className={styles["footer"]}>
			<i>&#xe610;</i>
			<p>- {t("moreToolsComingSoon")} -</p>
			<a
				className="link"
				href="mailto:aitools@retinbox.com"
			>
				<FontAwesomeIcon icon={faEnvelope} />
				{t("provideFeedbackAndSuggestions")}
			</a>
			<div className={styles["disclaimer"]}>{t("aigcDisclaimer")}</div>
		</footer>
	);
}

export default AiToolsFooter;
